import React from 'react'
import BubbleChartIcon from '@material-ui/icons/BubbleChartOutlined'
import { createColumnInstance } from '../../constants'

// Default axes: Standard Deviation (risk) on X, Performance (return) on Y.
const STDDEV = createColumnInstance('groupStatistic', { statisticType: 'Standard Deviation' })
const PERFORMANCE = createColumnInstance('performance')

// Additional axis options so the user can swap risk or return measures
// from the picker without leaving the chart. Each is instantiated once
// at module load so the references stay stable across renders.
const SHARPE = createColumnInstance('groupStatistic', { statisticType: 'Sharpe Ratio' })
const SORTINO = createColumnInstance('groupStatistic', { statisticType: 'Sortino Ratio' })
const BETA = createColumnInstance('groupStatistic', { statisticType: 'Beta Coefficient' })
const R_SQUARED = createColumnInstance('groupStatistic', { statisticType: 'R-Squared' })
const JENSENS_ALPHA = createColumnInstance('groupStatistic', { statisticType: "Jensen's Alpha" })
const TREYNOR = createColumnInstance('groupStatistic', { statisticType: 'Treynor Ratio' })
const DRAWDOWN = createColumnInstance('groupStatistic', { statisticType: 'Drawdown' })
const UPSIDE_CAPTURE = createColumnInstance('groupStatistic', { statisticType: 'Upside Capture Ratio' })
const DOWNSIDE_CAPTURE = createColumnInstance('groupStatistic', { statisticType: 'Downside Capture Ratio' })

const BENCHMARK_PERFORMANCE = createColumnInstance('benchmarkPerformance')

const EXTRAS = [
  SHARPE,
  SORTINO,
  BETA,
  R_SQUARED,
  JENSENS_ALPHA,
  TREYNOR,
  DRAWDOWN,
  UPSIDE_CAPTURE,
  DOWNSIDE_CAPTURE,
  BENCHMARK_PERFORMANCE
].filter(Boolean)

export const riskVsReturn = Object.freeze({
  id: 'risk-vs-return',
  name: 'Risk vs Return',
  description: 'Standard Deviation against Performance, one point per group.',
  renderIcon: () => <BubbleChartIcon style={{ fontSize: 16 }} />,
  toolId: 'scatter',
  resolve: ({ config }) => ({
    ok: true,
    payload: {
      scope: 'header',
      groupingLabel: config?.groupings?.[0] || null,
      axisXColumnInstance: STDDEV,
      axisYColumnInstance: PERFORMANCE,
      extraColumns: EXTRAS
    }
  })
})
